"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useMemo, useRef } from "react";
import { InstantSearch, Configure, Index } from "react-instantsearch";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { useParams } from "next/navigation";
import { LayoutSearch } from "@/components/terra/layouts/LayoutSearch/LayoutSearch";
import type { SearchQuickLink } from "@/components/terra/layouts/LayoutSearch/LayoutSearch";
import { ThemeDivider } from "@/components/terra/component/ThemeDivider/ThemeDivider";
import AutocompleteSearchBox from "@/components/client/SiteNavigation/NavSearch/AutocompleteSearchBox";
import CustomHits from "@/components/client/SiteNavigation/NavSearch/CustomHits";
import CustomStats from "@/components/client/SiteNavigation/NavSearch/CustomStats";
import InsightsMiddleware from "@/components/client/SiteNavigation/NavSearch/InsightsMiddleware";
import SearchReset from "@/components/client/SectionBlogDigest/Search/SearchReset";
import { getLocaleFilter } from "@/components/client/SiteNavigation/NavSearch/NavSearchMethods";
import { useSearchLabels } from "@/components/client/SiteNavigation/NavSearch/SearchLabelsContext";
import "@/components/client/SiteNavigation/NavSearch/NavSearch.css";
import useSearchClient from "@/lib/useSearchClient";
import { useAlgoliaConsent } from "@/lib/algoliaConsent";
import { handleButtons, normalToMachineTheme } from "@/lib/utils";
import profile from "@/profiles/profileSingleton";
export default function MXPLayoutSearch(props) {
  const $ = _c(47);
  const {
    value,
    index,
    divider,
    headerElement,
    isStrictLocale: t0
  } = props;
  const isStrictLocale = t0 === undefined ? true : t0;
  const params = useParams();
  const locale = params?.lang as string || "en";
  const labels = useSearchLabels();
  const [currentRefinement, setCurrentRefinement] = useState("");
  const searchWrapperRef = useRef(null);
  const crawlerIndex = profile.NEXT_PUBLIC_ALGOLIA_SITE_INDEX || profile.NEXT_PUBLIC_ALGOLIA_GLOBAL_INDEX || "crawler_external_sites";
  const hitsPerPage = profile.NEXT_PUBLIC_ALGOLIA_SEARCH_HITS_PER_PAGE ? parseInt(profile.NEXT_PUBLIC_ALGOLIA_SEARCH_HITS_PER_PAGE) : 10;
  const {
    searchClient,
    combinedNbHits,
    currentPageNumber
  } = useSearchClient();
  const {
    hasAlgoliaConsent
  } = useAlgoliaConsent();
  let t1;
  if ($[0] !== isStrictLocale || $[1] !== locale) {
    t1 = getLocaleFilter(locale, isStrictLocale);
    $[0] = isStrictLocale;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const indexLocaleFilter = t1;
  let parts;
  if ($[3] !== indexLocaleFilter || $[4] !== value.algoliaQueryFilters) {
    parts = [indexLocaleFilter];
    if (value.algoliaQueryFilters) {
      parts.push(value.algoliaQueryFilters);
    }
    $[3] = indexLocaleFilter;
    $[4] = value.algoliaQueryFilters;
    $[5] = parts;
  } else {
    parts = $[5];
  }
  const combinedFilter = parts.join(" AND ");
  const t2 = value.buttonsCollection?.items;
  let t3;
  if ($[6] !== locale || $[7] !== t2) {
    t3 = handleButtons(t2, true, locale);
    $[6] = locale;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const buttons = t3;
  let t4;
  if ($[9] !== value.searchQuickLinksCollection?.items) {
    t4 = value.searchQuickLinksCollection?.items?.filter(_temp).map(_temp2) || [];
    $[9] = value.searchQuickLinksCollection?.items;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const quickLinks = t4;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = searchString => {
      setCurrentRefinement(searchString);
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleQuickLinkClick = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setCurrentRefinement("");
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const resetClick = t6;
  let t7;
  if ($[13] !== value.theme) {
    t7 = normalToMachineTheme(value.theme);
    $[13] = value.theme;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const presetTheme = t7;
  const dividerClasses = `section-divider-wrap ${value.theme}`;
  let t8;
  if ($[15] !== combinedFilter || $[16] !== combinedNbHits || $[17] !== currentPageNumber || $[18] !== currentRefinement || $[19] !== hasAlgoliaConsent || $[20] !== labels || $[21] !== locale || $[22] !== searchClient || $[23] !== value.searchPlaceholderText) {
    t8 = searchClient ? <div className="nav-search" ref={searchWrapperRef} style={{
      paddingBottom: 0
    }}><InstantSearch indexName={crawlerIndex} searchClient={searchClient} future={{
        preserveSharedStateOnUnmount: true
      }}><Configure clickAnalytics={true} /><InsightsMiddleware /><AutocompleteSearchBox searchPlaceholderText={value.searchPlaceholderText} currentRefinement={currentRefinement} setCurrentRefinement={setCurrentRefinement} hasAlgoliaConsent={hasAlgoliaConsent} /><div className="nav-search__filter-panel"><Configure filters={combinedFilter} attributesToRetrieve={["*"]} hitsPerPage={hitsPerPage} clickAnalytics={true} facets={["*"]} /></div>{currentRefinement?.length >= 2 && <><SearchReset resetClick={resetClick} resetSearchText={labels.reset} /><CustomStats currentPageNumber={currentPageNumber} /><Index indexName={crawlerIndex}><Configure hitsPerPage={hitsPerPage} filters={combinedFilter} clickAnalytics={true} /><CustomHits minHitsPerPage={hitsPerPage} totalHits={combinedNbHits} searchWrapperRef={searchWrapperRef} locale={locale} /></Index></>}</InstantSearch></div> : null;
    $[15] = combinedFilter;
    $[16] = combinedNbHits;
    $[17] = currentPageNumber;
    $[18] = currentRefinement;
    $[19] = hasAlgoliaConsent;
    $[20] = labels;
    $[21] = locale;
    $[22] = searchClient;
    $[23] = value.searchPlaceholderText;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const searchContent = t8;
  const t9 = value.eyebrow;
  const t10 = value.header;
  const t11 = value.subheader;
  const t12 = value?.description?.json;
  let t13;
  if ($[25] !== t12) {
    t13 = documentToHtmlString(t12);
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const t14 = value.isHeaderBig || false;
  let t15;
  if ($[27] !== buttons || $[28] !== headerElement || $[29] !== index || $[30] !== presetTheme || $[31] !== quickLinks || $[32] !== searchContent || $[33] !== t13 || $[34] !== t14 || $[35] !== value.eyebrow || $[36] !== value.header || $[37] !== value.searchPlaceholderText || $[38] !== value.subheader) {
    t15 = <LayoutSearch key={index} eyebrow={t9} header={t10} subheader={t11} description={t13} presetTheme={presetTheme} isHeaderBig={t14} isWrapped={true} buttons={buttons} searchPlaceholderText={value.searchPlaceholderText} quickLinks={quickLinks} onQuickLinkClick={handleQuickLinkClick} searchContent={searchContent} headerElement={headerElement} />;
    $[27] = buttons;
    $[28] = headerElement;
    $[29] = index;
    $[30] = presetTheme;
    $[31] = quickLinks;
    $[32] = searchContent;
    $[33] = t13;
    $[34] = t14;
    $[35] = value.eyebrow;
    $[36] = value.header;
    $[37] = value.searchPlaceholderText;
    $[38] = value.subheader;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== divider || $[41] !== dividerClasses || $[42] !== value.theme) {
    t16 = divider && <div className={dividerClasses}><ThemeDivider currentTheme={value.theme} /></div>;
    $[40] = divider;
    $[41] = dividerClasses;
    $[42] = value.theme;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t15 || $[45] !== t16) {
    t17 = <>{t15}{t16}</>;
    $[44] = t15;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  return t17;
}
function _temp2(link_0) {
  return {
    id: link_0.sys?.id,
    title: link_0.title,
    searchString: link_0.searchString
  };
}
function _temp(link) {
  return link != null;
}